export default "__VITE_ASSET__B3_kBYa5__"